(function () {
    'use strict';

    function ServiceItemAmenitiesController($scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $uibModal, ServiceItemCustom) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;


        loadAll();
        loadPage();

        function loadAll() {

            ServiceItemCustom.getAllAmenitiesType().query().$promise.then(function (result) {

                if ($ctrl.amenities == null || $ctrl.amenities == undefined || $ctrl.amenities.length == 0) {
                    $ctrl.amenities = result;
                    return;
                }
                angular.forEach(result, function (v) {

                    var isFound = false;
                    angular.forEach($ctrl.amenities, function (am) {

                        if (am.amenitiesType == v.amenitiesType) {
                            isFound = true;
                        }

                    });

                    if (isFound == false) {
                        $ctrl.amenities.push({
                            amenitiesType: v.amenitiesType,
                            price: 0.0,
                            qty: 1.0,
                            selected: false
                        });
                    }
                });


            });


        }

        function loadPage(page) {
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('amenitiesType');
            translatePartialLoader = translate.refresh();
            //

        }

    }

    var ServiceItemAmenities = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-amenities/partial-form.service-item-amenities.html',
        controller: ServiceItemAmenitiesController,
        bindings: {
            amenities: '='
        }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemAmenities', ServiceItemAmenities)

    ServiceItemAmenitiesController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$uibModal', 'ServiceItemCustom'];


})();

